export const routes = [
    {
        path: '/'
    },
    {
        path: '/catalogue/:loanFormat?'
    },
    {
        path: '/products/:productId'
    },
    {
        path: '/orderlists/:id'
    },
    {
        path: '/bundles/:bundleId'
    },
    {
        path: '/cart/'
    },
    {
        path: '/checkout'
    },
    {
        path: '/checkout/thanks'
    },
    {
        path: '/orders'
    },
    {
        path: '/orders/:orderId'
    },
    {
        path: '/search/:pathParam1?/:pathParam2?'
    },
    {
        path: '/assistant'
    },
    {
        path: '/reporting*'
    },
    {
        path: '/collection'
    },
    {
        path: '/localcontent'
    },
    {
        path: '/terms'
    },
    {
        path: '/libxchange'
    },
    {
        path: '/language'
    },
    {
        path: '/unlimited'
    },
    {
        path: '/marketing'
    }
];
